import React, { useState } from 'react';
import { QuestRoute } from './api/QuestRoutes';
import Col from './layout/Col';
import Loader from './Loader';

const CompanyAddress = ({ text = false, ...props }) => {
    const [data, setData] = useState({})

    return (
        <Loader
            route={QuestRoute.settings.header}
            setData={setData}
        >
            <Col>
                <b>{data.companyName}</b>
                <span>{data.address} {data.address2}</span>
                <span>{data.city}, {data.stateProvince} {data.zipPostalCode}</span>
            </Col>
        </Loader>
    );
}

export default CompanyAddress;
